import React from 'react';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  background?: 'ivory' | 'sand' | 'charcoal';
}
export function Section({
  children,
  className = '',
  id,
  background = 'ivory'
}: SectionProps) {
  const bgColors = {
    ivory: 'bg-ivory text-charcoal',
    sand: 'bg-sand text-charcoal',
    charcoal: 'bg-charcoal text-ivory'
  };
  return <section id={id} className={`py-24 md:py-32 relative overflow-hidden ${bgColors[background]} ${className}`} data-id="element-741" data-mp="35uoy83jymz8g">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-742" data-mp="30usvs8qwvfv0">
        {children}
      </div>
    </section>;
}